import React from 'react';
import { Tag } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { whatsappApi } from '../../utils/api';

const providerLabels = {
  whatchimp: 'WhatChimp',
  wati: 'WATI',
  wasenderapi: 'WasenderAPI',
  aisensy: 'AiSensy'
};

/**
 * Indique dans les interfaces d'envoi quel moteur transmet réellement les messages.
 * Le badge est masqué avec la connexion directe afin de ne pas modifier les écrans existants.
 */
const WhatsAppProviderBadge = () => {
  /**
   * Charge le statut de connexion pour identifier l'intégration API active sans demander ses secrets.
   */
  const { data } = useQuery({
    queryKey: ['whatsapp-provider-status'],
    queryFn: async () => {
      const { data: response } = await whatsappApi.getStatus();
      return response;
    },
    staleTime: 30000,
    retry: false
  });

  if (data?.connection_type !== 'api') return null;

  return (
    <Tag color="blue">
      Messages envoyés via {providerLabels[data.integration?.provider] || 'votre plateforme WhatsApp API'}
    </Tag>
  );
};

export default WhatsAppProviderBadge;
